import { __ } from '@wordpress/i18n';
import clsx from 'clsx';
import PanelSettings from './advance/inspector-control';
import Advance from './advance';
import { VayuBlocksDevice } from '@vayu-blocks/device-control';
import { VayuBlocksUniqueId } from '@vayu-blocks/global';
import { useSelect, useDispatch } from '@wordpress/data';
import { InnerBlocks } from '@wordpress/block-editor';
import { useState, useEffect, useRef, useMemo } from '@wordpress/element';
import { borderStyle, borderRadiusStyle,boxShadow,dimensions} from "@vayu-blocks/global";
import {GetIcon} from '@vayu-blocks';

const useFaqParentInfo = (clientId) => {
	return useSelect((select) => {
		const { getBlockParents, getBlock, getBlockOrder } = select('core/block-editor');

		const parentIds = getBlockParents(clientId);
		const faqParentId = parentIds.find((id) => getBlock(id)?.name === 'vayu-blocks/faq');

		if (!faqParentId) return {};

		const parentBlock = getBlock(faqParentId);
		const childIds = getBlockOrder(faqParentId);

		return {
			...parentBlock.attributes,
			clientId: faqParentId,
			firstChildId: childIds?.[0],
			firstTwoChildIds: childIds?.slice(0, 2),
		};
	}, [clientId]);
};


const useInitialOpenState = ({
	isAccordation,
	parentInfo,
	clientId,
	setIsOpen,
	updateBlockAttributes,
}) => {
	const didInit = useRef(false);

	useEffect(() => {
		if (didInit.current) return;

		if (
			isAccordation &&
			parentInfo.expandfirst &&
			// !parentInfo.activeChildId &&
			parentInfo.firstChildId === clientId
		) {
			updateBlockAttributes(parentInfo.clientId, {
				activeChildId: clientId,
			});
			didInit.current = true;
		}

		if (
			isAccordation &&
			!parentInfo.collapseall &&
			!parentInfo.activeChildId
		) {
			setIsOpen(true);
			didInit.current = true;
		}
	}, [
		isAccordation,
		parentInfo.expandfirst,
		parentInfo.collapseall,
		parentInfo.activeChildId,
		parentInfo.firstChildId,
		clientId,
		updateBlockAttributes,
		parentInfo.clientId,
	]);
};

const edit = ({ attributes, setAttributes, clientId, isSelected }) => {
	
	const view = VayuBlocksDevice();
	VayuBlocksUniqueId({ setAttributes, clientId });

	const [hovered, setHovered] = useState(false);
	const [iconhovered, setIconHovered] = useState(false);

	const image_template = useMemo(() => [
		[
        'vayu-blocks/advance-container',
        {
			metadata:{name:'Question'},
			className: 'vb-faq-child-question',
            contFlex: {
				justifyContent:{ Desktop: 'center', Tablet: 'center', Mobile: 'center', },
				alignItems:{ Desktop: 'left', Tablet: 'left', Mobile: 'left', },
            },
			advPadding:{Desktop:{left: 'var:preset|vayu-blocks-spacing|10', right:"0px", top:"0px", bottom:"0px"}, Tablet:{left: 'var:preset|vayu-blocks-spacing|10', right:"0px", top:"0px", bottom:"0px"}, Mobile:{left: 'var:preset|vayu-blocks-spacing|10', right:"0px", top:"0px", bottom:"0px"}},
			contentWidthType:'fullwidth',
			fullcontentWidth:{Desktop:'95%', Tablet:'95%', Mobile:'95%'}
        },
        [
            [
			'vayu-blocks/advance-heading',
			{
				content: 'What is FAQ?',
				placeholder: 'Write your question...',
				align: {
					Desktop: 'left',
					Tablet: 'left',
					Mobile: 'left',
				},
				typography : { 
				fonts: {},
				fontSize: {
					Desktop: '20px',
					Tablet: '20px',
					Mobile: '20px'
				},
				appearance: {},
				lineHeights: {},
				letterSpacing: {},
				decoration: {},
				orientation: {},
				letterCase: {}
				}
			},
			],
        ],
        ],
		[
        'vayu-blocks/advance-container',
        {
			className: 'vb-faq-child-answer',
			metadata:{name:'Answer'},
        },
        [
            [
			'vayu-blocks/advance-heading',
			{
				placeholder: 'Write your answer...',
				content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
				align: {
					Desktop: 'left',
					Tablet: 'left',
					Mobile: 'left',
				},
				typography : { 
					fonts: {},
					fontSize: {
						Desktop: '20px',
						Tablet: '20px',
						Mobile: '20px'
					},
					appearance: {},
					lineHeights: {},
					letterSpacing: {},
					decoration: {},
					orientation: {},
					letterCase: {}
				},
				tag: "p",
			},
			],
        ],
        ],
	], []);

	const { updateBlockAttributes } = useDispatch('core/block-editor');
	const parentInfo = useFaqParentInfo(clientId);

	const [isOpen, setIsOpen] = useState(false);
	const [hasClicked, setHasClicked] = useState(false);

	const isGrid = parentInfo?.showtype === 'grid';
	const isAccordation = parentInfo?.showtype === 'accordation';
	const isActive = parentInfo?.activeChildId === clientId;

	useInitialOpenState({
		isAccordation,
		parentInfo,
		clientId,
		setIsOpen,
		updateBlockAttributes,
	});

	const shouldForceOpen = isAccordation && !parentInfo.collapseall && !hasClicked;
	const openState = isGrid ? true : shouldForceOpen ? true : isAccordation ? isActive : isOpen;

	const toggleOpen = () => {
		if (isGrid) return;

		setHasClicked(true);

		if (isAccordation) {
			if (parentInfo.enabletoggle) {
				updateBlockAttributes(parentInfo.clientId, {
					activeChildId: isActive ? '' : clientId,
				});
			} else {
				if (!isActive) {
					updateBlockAttributes(parentInfo.clientId, {
						activeChildId: clientId,
					});
				}
			}
		} else {
			setIsOpen(!isOpen);
		}
	};

	const wrapperClass = clsx('vb-faq-child-wrapper', {
		open: openState,
		closed: !openState,
		'vb-grid-layout': isGrid,
	});

	const containerStyle = {
		background: hovered
			? parentInfo?.containerbghvr || parentInfo?.containerbg
			: parentInfo?.containerbg,
		transition: 'all 0.3s ease',

		...borderStyle(parentInfo.contBorder, view),
		...borderRadiusStyle(parentInfo.contBorderRadius, view),
		...boxShadow(parentInfo.contDropShadow, view),
		boxSizing:'border-box',
		overflow:'hidden',

		...(hovered
		? {
			...borderStyle(parentInfo.contBorderHover, view, parentInfo.contBorder),
			...borderRadiusStyle(parentInfo.contBorderRadiusHover, view, parentInfo.contBorderRadius),
			...boxShadow(parentInfo.contDropShadowHover, view, parentInfo.contDropShadow),
		  }
		: {}),
	};

	const iconStyle = {
		background: iconhovered
			? parentInfo?.iconbghvr || parentInfo?.iconbg
			: parentInfo?.iconbg,
		color: openState
			? (parentInfo?.iconactivecolor || parentInfo?.iconcolor)
			: iconhovered
				? parentInfo?.iconcolorhvr || parentInfo?.iconcolor
				: parentInfo?.iconcolor,
		fill: openState
			? (parentInfo?.iconactivecolor || parentInfo?.iconcolor)
			: iconhovered
				? parentInfo?.iconcolorhvr || parentInfo?.iconcolor
				: parentInfo?.iconcolor,
		...borderStyle(parentInfo.iconBorder, view),
		...borderRadiusStyle(parentInfo.iconBorderRadius, view),
		...boxShadow(parentInfo.iconDropShadow, view),
		boxSizing:'border-box',
		padding: dimensions(parentInfo.iconPadding, view),
		top: parentInfo?.icontop?.[view],
		left: parentInfo?.iconleft?.[view],
	}

	const isFirstTwoGridChild =
	isGrid && parentInfo?.firstTwoChildIds?.includes(clientId);

	useEffect(() => {
		setAttributes({
			faqMeta: {
				showtype: parentInfo.showtype,
				expandfirst: !!parentInfo.expandfirst,
				collapseall: !!parentInfo.collapseall,
				isFirstChild: parentInfo.firstChildId === clientId,
				activeprintedIcon: parentInfo.activeiconName,
				inactiveprintedIcon:parentInfo.inactiveiconName,
				enabletoggle:parentInfo.enabletoggle,
				click: parentInfo.click,
			},
		});
	}, [
		parentInfo.showtype,
		parentInfo.expandfirst,
		parentInfo.collapseall,
		parentInfo.firstChildId,
		parentInfo?.activeiconName,
		parentInfo?.inactiveiconName,
		parentInfo?.enabletoggle,
		parentInfo?.click,
		clientId,
	]);

	useEffect(() => {
		if ( isAccordation  && parentInfo.firstChildId === clientId && parentInfo.expandfirst) {
			updateBlockAttributes(parentInfo.clientId, {
				activeChildId: clientId,
			});
		}
		if(isAccordation && parentInfo.activeChildId === clientId && !parentInfo.expandfirst){
			updateBlockAttributes(parentInfo.clientId, {
				activeChildId: '',
			});
		}
	}, [parentInfo.expandfirst]);

	return (
		<>
			<PanelSettings isSelected={isSelected} />

			<Advance 
				attributes={attributes} 
				clientId={clientId} 
				alwaysOpen={isGrid}  
				rowgap={ isFirstTwoGridChild ? '0px' : parentInfo?.rowgap?.[view] || undefined}
			>

				<div
					className={wrapperClass}
					style={containerStyle}
					onMouseEnter={() => setHovered(true)}
					onMouseLeave={() => setHovered(false)}
				>
				
					<InnerBlocks
						template={image_template}
						allowedBlocks={['vayu-blocks/advance-heading']}
						templateLock="all"
						renderAppender={false}
					/>

					{!isGrid && (
						<span
							onClick={!isGrid ? toggleOpen : undefined}
							className="vb-faq-icon"
							style={iconStyle}
							onMouseEnter={() => setIconHovered(true)}
							onMouseLeave={() => setIconHovered(false)}
						>

							<GetIcon
								value={
									openState
										? attributes.faqMeta?.activeprintedIcon || ''
										: attributes.faqMeta?.inactiveprintedIcon || ''
								}
							/>
						</span>
					)}
				</div>

			</Advance>
		</>
	);
};

export default edit;
